import { default as _91menu_93dAYrxMjKNAMeta } from "/home/runner/work/ansbbq.website/ansbbq.website/app/pages/[menu].vue?macro=true";
import { default as indexyPHB1v1AfwMeta } from "/home/runner/work/ansbbq.website/ansbbq.website/app/pages/index.vue?macro=true";
export default [
  {
    name: "menu",
    path: "/:menu()",
    meta: _91menu_93dAYrxMjKNAMeta || {},
    component: () => import("/home/runner/work/ansbbq.website/ansbbq.website/app/pages/[menu].vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexyPHB1v1AfwMeta || {},
    component: () => import("/home/runner/work/ansbbq.website/ansbbq.website/app/pages/index.vue")
  }
]